import { render, staticRenderFns } from "./CompanyOffers.vue?vue&type=template&id=839ded86"
import script from "./CompanyOffers.vue?vue&type=script&lang=js"
export * from "./CompanyOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports